import { Loader2 } from "lucide-react";
import { Play } from "lucide-react";
import { Copy } from "lucide-react";
import { Trash2 } from "lucide-react";

export const getActionColumn = (actionsColumn, actionConfig) => {
  return {
    id: "actions",
    header: "Actions",
    meta: {
      columnName: "Actions",
      columnInfo: {
        tip_text: "Actions you can perform on this item",
      },
    },
    cell: ({ row }) => {
      const rowId = row.id;
      return (
        <div className="flex items-center gap-2 justify-center">
          {actionsColumn.map((action) => {
            switch (action) {
              case "launch":
                if (row.original.status.display === "launched") {
                  return null;
                }
                return (
                  <button
                    key={action}
                    onClick={(e) => {
                      e.stopPropagation();
                      actionConfig?.launch?.onClick(row);
                    }}
                    disabled={actionConfig?.launch?.isLoading(rowId)}
                  >
                    {!actionConfig?.launch?.isLoading(rowId) ? (
                      <Play className="h-4 w-4 text-green-600" />
                    ) : (
                      <Loader2 className="h-4 w-4 text-green-600 animate-spin" />
                    )}
                  </button>
                );
              case "duplicate":
                return (
                  <button
                    key={action}
                    onClick={(e) => {
                      e.stopPropagation();
                      actionConfig?.duplicate?.onClick(row);
                    }}
                    disabled={actionConfig?.duplicate?.isLoading(rowId)}
                  >
                    {!actionConfig?.duplicate?.isLoading(rowId) ? (
                      <Copy className="h-4 w-4 text-blue-600" />
                    ) : (
                      <Loader2 className="h-4 w-4 text-blue-600 animate-spin" />
                    )}
                  </button>
                );
              case "delete":
                return (
                  <button
                    key={action}
                    onClick={(e) => {
                      e.stopPropagation();
                      actionConfig?.delete?.onClick(row);
                    }}
                    disabled={actionConfig?.delete?.isLoading(rowId)}
                  >
                    {!actionConfig?.delete?.isLoading(rowId) ? (
                      <Trash2 className="h-4 w-4 text-red-600" />
                    ) : (
                      <Loader2 className="h-4 w-4 text-red-600 animate-spin" />
                    )}
                  </button>
                );
            }
          })}
          {/* <button
          onClick={(e) => {
            e.stopPropagation();
            console.log("row to delete", row.original);
            // implement delete functionality here
            // delete the row.original from the table
            // table.options.meta.deleteData?.(row.original);
            toast.success("Deleted");
          }}
          className="p-1 rounded hover:bg-red-100 text-red-600"
          title="Delete"
        >
          <Trash2 className="h-4 w-4" />
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            // implement copy functionality here
            // copy the row.original to the clipboard
            navigator.clipboard.writeText(JSON.stringify(row.original));
            toast.success("Copied to clipboard");
          }}
          className="p-1 rounded hover:bg-blue-100 text-blue-600"
          title="Copy"
        >
          <Copy className="h-4 w-4" />
        </button> */}
        </div>
      );
    },
    enableGlobalFilter: false,
    enableSorting: false,
    enableColumnFilter: false,
    size: window.innerWidth < 640 ? 110 : 200,
  };
};
